const bulkPopup = () => {
    const corporate_btn = document.querySelector(".desktop-pdp-custom-corprate-button"),
        bulk_form_state = document.querySelector('.bulk-form-state');

    if (bulk_form_state) {
        const bulkpopupContainer = document.querySelector(".popup_bulk_container"),
            close_up_btn = document.querySelector(".bulk_close_popup"),
            bulkcloseIconBtn = document.querySelector(".bulk_close_btn"),
            bulknotifySend = bulk_form_state.querySelector('#bulksendButton'),
            bulkProductForm = bulk_form_state.querySelector('#ContactForm-bulkForm');
        bulkthankYouMessage = document.getElementById('bulk_thank_you'),
            fields = bulkProductForm.querySelectorAll('input,textarea');

        if (corporate_btn) {
            corporate_btn.addEventListener("click", function (event) {
                event.preventDefault();
                bulkpopupContainer.classList.add('active');
                document.body.classList.add('overlay_bulkpopup');
            });
        }

        if (close_up_btn) {
            close_up_btn.addEventListener("click", function (event) {
                event.preventDefault();
                bulkpopupContainer.classList.remove('active');
                document.body.classList.remove('overlay_bulkpopup');
            });
        }

        if (bulkcloseIconBtn) {
            bulkcloseIconBtn.addEventListener("click", function (event) {
                event.preventDefault();
                bulkpopupContainer.classList.remove("active");
                document.body.classList.remove("overlay_bulkpopup");
                bulkProductForm.submit();
            });
        }

        fields.forEach(field => {
            field.addEventListener('blur', validateField);
        });

        function validateField(event) {
            const field = event.target;
            const fieldWrap = field.closest('.field');
            if (!fieldWrap) return;
            const errorSpan = fieldWrap.querySelector('.form-err-msg');
            if (!errorSpan) return;
            var errorMessage = '';
            switch (field.name) {
                case 'contact[Full Name]':
                    if (field.value.trim() === '') {
                        errorMessage = 'Name field is required';
                    }
                    break;
                case 'contact[email]':
                    if (field.value.trim() === '') {
                        errorMessage = 'Email field is required';
                    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value)) {
                        errorMessage = 'Invalid email address';
                    }
                    break;
                case 'contact[Phone Number]':
                    if (field.value.trim() === '') {
                        errorMessage = 'phone field is required';
                    }
                    else if (!/^\d{10}$/.test(field.value)) {
                        errorMessage = 'Phone number must be 10 digits';
                    }
                    break;
                case 'contact[pincode]':
                    if (field.value.trim() === '') {
                        errorMessage = 'Pincode field is required';
                    }
                    break;
                case 'contact[State]':
                    if (field.value.trim() === '') {
                        errorMessage = 'State field is required';
                    }
                    break;
                case 'contact[City]':
                    if (field.value.trim() === '') {
                        errorMessage = 'City field is required';
                    }
                    break;
                case 'contact[Product Required]':
                    if (field.value.trim() === '') {
                        errorMessage = 'Product name field is required';
                    }
                    break;
                case 'contact[Quantity Required]':
                    if (field.value.trim() === '') {
                        errorMessage = 'Quantity field is required';
                    }
                    else if (field.value < 5) {
                        errorMessage = 'Value must be greater than or equal to 5.';
                    }
                    break;
                case 'contact[Reason]':
                    if (field.value.trim() === '') {
                        errorMessage = 'Reason field is required';
                    }
                    break;
                default:
                    console.log('Default case');
                    break;
            }
            if (errorSpan.textContent != null) {
                errorSpan.textContent = errorMessage;
            }
        }

        bulknotifySend.addEventListener('click', function (event) {
            event.preventDefault();
            const username = bulk_form_state.querySelector('[name="contact[Full Name]"]').value,
                fromEmail = bulk_form_state.querySelector('[name="contact[From Email ID]"]').value,
                mobile_number = bulk_form_state.querySelector('[name="contact[Phone Number]"]').value,
                email = bulk_form_state.querySelector('[name="contact[email]"]').value,
                pincode = bulk_form_state.querySelector('[name="contact[pincode]"]').value,
                state = bulk_form_state.querySelector('[name="contact[State]"]').value,
                city = bulk_form_state.querySelector('[name="contact[City]"]').value,
                productRequired = bulk_form_state.querySelector('[name="contact[Product Required]"]').value,
                qtyRequired = bulk_form_state.querySelector('[name="contact[Quantity Required]"]').value,
                targetPrice = bulk_form_state.querySelector('[name="contact[Targeted Price]"]').value,
                tentative = bulk_form_state.querySelector('[name="contact[Tentative Timeline]"]').value,
                reason = bulk_form_state.querySelector('[name="contact[Reason]"]').value;

            if (username.trim() === '' || mobile_number.trim() === '' || email.trim() === '' || pincode.trim() === '' || state.trim() === '' || city.trim() === '' || productRequired.trim() === '' || qtyRequired.trim() === '' || reason.trim() === '') {
                alert('Please fill out all fields');
                return false;
            }
            const emailPattern = /^[^@]+@[^@]+\.[^@]+$/;
            if (!emailPattern.test(email)) {
                alert('Please enter a valid email address');
                return false;
            }

            const mobilePattern = /^\d{10}$/;
            if (!mobilePattern.test(mobile_number)) {
                alert('Please enter a valid 10-digit mobile number');
                return false;
            }

            if (qtyRequired < 5) {
                alert('Value must be greater than or equal to 5.');
                return false;
            }

            bulknotifySend.classList.add('loading');
            fetch('https://cpanel.mensabrands.com/BulkOrder/public/addData', {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-type": "application/json",
                    "Authorization": `Bearer ${window.sessionToken}`
                },
                body: JSON.stringify({
                    full_name: username,
                    email: email,
                    phone_number: mobile_number,
                    pincode: pincode,
                    state: state,
                    city: city,
                    product_required: productRequired,
                    quantity_required: qtyRequired,
                    targeted_price: targetPrice,
                    tentative_timelines: tentative,
                    reason: reason,
                    fromEmail: fromEmail
                })
            })
                .then(res => {
                    setTimeout(() => {
                        bulkProductForm.submit();
                    }, 5000);
                    bulkthankYouMessage.style.display = 'block';
                    if (close_up_btn) {
                        close_up_btn.style.display = 'none';
                    }
                    bulknotifySend.classList.remove('loading');
                    const parent = bulk_form_state.parentElement;
                    if (parent.classList.contains('popup-scroller')) {
                        parent.style.display = 'none';
                    }
                    else {
                        bulk_form_state.style.display = 'none';
                    }
                })
        });

        initBulkProductPicker(bulkProductForm);
    }
}

function initBulkProductPicker(form) {
    const productInput = form.querySelector('[name="contact[Product Required]"]');
    const picker = document.getElementById('bulk-product-picker');
    if (!productInput || !picker) return;

    document.body.appendChild(picker);

    const searchInput = picker.querySelector('#bulk-product-search');
    const list = picker.querySelector('#bulk-product-list');
    const countEl = picker.querySelector('#bulk-product-count');
    const addButton = picker.querySelector('#bulk-product-add');
    const confirmed = new Map();
    let draft = new Map();
    let currentProducts = [];
    let requestId = 0;
    let searchTimer = null;
    const productCache = new Map();

    function storePath(path) {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return root.replace(/\/?$/, '/') + String(path).replace(/^\//, '');
    }

    function escapeHtml(value) {
        return String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function toCents(price) {
        if (typeof price === 'string') return Math.round(parseFloat(price) * 100);
        return Number(price) || 0;
    }

    function formatMoney(cents) {
        const value = cents / 100;
        if (Number.isInteger(value)) return '₹' + value.toLocaleString('en-IN');
        return '₹' + value.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function imageUrl(product) {
        let image = product.featured_image || product.image || '';
        if (!image && product.images && product.images[0]) image = product.images[0].src;
        if (image && typeof image === 'object') image = image.src || image.url || '';
        if (typeof image !== 'string' || !image) return '';
        return image.indexOf('//') === 0 ? 'https:' + image : image;
    }

    function normalizeProduct(product) {
        const variants = (product.variants || []).map(function (variant) {
            return {
                id: variant.id,
                title: variant.title,
                price: toCents(variant.price),
                available: !!variant.available
            };
        });
        return {
            id: product.id,
            title: product.title,
            handle: product.handle,
            image: imageUrl(product),
            variants: variants
        };
    }

    function variantLabel(product, variant) {
        if (!variant.title || variant.title === 'Default Title') return product.title;
        return product.title + ' - ' + variant.title;
    }

    function updateCount() {
        const total = draft.size;
        countEl.textContent = total ? total + ' selected' : '';
    }

    function syncProductCheckbox(product) {
        const box = list.querySelector('[data-product-check="' + product.id + '"]');
        if (!box) return;
        const picked = product.variants.filter(function (variant) {
            return draft.has(String(variant.id));
        }).length;
        box.checked = product.variants.length > 0 && picked === product.variants.length;
        box.indeterminate = picked > 0 && picked < product.variants.length;
    }

    function renderProducts(products) {
        currentProducts = products;
        if (!products.length) {
            list.innerHTML = '<p class="bulk-product-picker__status">No products found</p>';
            updateCount();
            return;
        }

        list.innerHTML = products.map(function (product) {
            const variants = product.variants.map(function (variant) {
                const checked = draft.has(String(variant.id)) ? ' checked' : '';
                const stock = variant.available ? 'In stock' : 'Out of stock';
                const stockClass = variant.available ? 'is-in' : 'is-out';
                const title = !variant.title || variant.title === 'Default Title' ? 'Default' : variant.title;
                return '<label class="bulk-product-picker__variant">' +
                    '<input type="checkbox" data-variant-id="' + variant.id + '" data-product-id="' + product.id + '"' + checked + '>' +
                    '<span class="bulk-product-picker__variant-copy">' +
                        '<span class="bulk-product-picker__variant-title">' + escapeHtml(title) + '</span>' +
                        '<span class="bulk-product-picker__stock ' + stockClass + '">' + stock + '</span>' +
                    '</span>' +
                    '<span class="bulk-product-picker__price">' + formatMoney(variant.price) + '</span>' +
                '</label>';
            }).join('');

            const image = product.image
                ? '<img src="' + escapeHtml(product.image) + '" alt="" width="40" height="40">'
                : '<span class="bulk-product-picker__image-fallback" aria-hidden="true"></span>';

            return '<article class="bulk-product-picker__product" data-product-id="' + product.id + '">' +
                '<label class="bulk-product-picker__product-row">' +
                    '<input type="checkbox" data-product-check="' + product.id + '">' +
                    image +
                    '<span class="bulk-product-picker__title">' + escapeHtml(product.title) + '</span>' +
                '</label>' +
                '<div class="bulk-product-picker__variants">' + variants + '</div>' +
            '</article>';
        }).join('');

        products.forEach(syncProductCheckbox);
        updateCount();
    }

    function findProduct(productId) {
        return currentProducts.find(function (product) {
            return String(product.id) === String(productId);
        });
    }

    async function fetchProductByHandle(handle) {
        if (productCache.has(handle)) return productCache.get(handle);
        const response = await fetch(storePath('/products/' + handle + '.js'));
        if (!response.ok) throw new Error('Product request failed');
        const product = normalizeProduct(await response.json());
        productCache.set(handle, product);
        return product;
    }

    async function loadProducts(query) {
        const id = ++requestId;
        list.innerHTML = '<p class="bulk-product-picker__status">Loading products…</p>';
        try {
            let products;
            const term = query.trim();
            if (!term) {
                const response = await fetch(storePath('/products.json?limit=12'));
                if (!response.ok) throw new Error('Product request failed');
                const data = await response.json();
                products = (data.products || []).map(normalizeProduct);
            } else {
                const params = new URLSearchParams({
                    q: term,
                    'resources[type]': 'product',
                    'resources[limit]': '8',
                    'resources[options][unavailable_products]': 'last'
                });
                const response = await fetch(storePath('/search/suggest.json?' + params.toString()));
                if (!response.ok) throw new Error('Search request failed');
                const data = await response.json();
                const matches = (data.resources && data.resources.results && data.resources.results.products) || [];
                const loaded = await Promise.all(matches.map(function (match) {
                    return fetchProductByHandle(match.handle).catch(function () {
                        return null;
                    });
                }));
                products = loaded.filter(Boolean);
            }
            if (id !== requestId) return;
            renderProducts(products.filter(function (product) {
                return product.variants.length;
            }));
        } catch (error) {
            if (id !== requestId) return;
            list.innerHTML = '<p class="bulk-product-picker__status">Could not load products. Please try again.</p>';
        }
    }

    function openPicker() {
        if (!picker.hidden) return;
        draft = new Map(confirmed);
        picker.hidden = false;
        document.body.classList.add('bulk-product-picker-open');
        searchInput.value = '';
        loadProducts('');
        window.setTimeout(function () {
            searchInput.focus();
            const errorSpan = productInput.closest('.field').querySelector('.form-err-msg');
            if (errorSpan) errorSpan.textContent = '';
        }, 0);
    }

    function closePicker() {
        picker.hidden = true;
        document.body.classList.remove('bulk-product-picker-open');
        productInput.focus();
    }

    function applySelection() {
        confirmed.clear();
        draft.forEach(function (value, key) {
            confirmed.set(key, value);
        });
        productInput.value = Array.from(confirmed.values()).map(function (item) {
            return item.label;
        }).join(', ');
        productInput.title = productInput.value;
        const errorSpan = productInput.closest('.field').querySelector('.form-err-msg');
        if (errorSpan) errorSpan.textContent = productInput.value.trim() ? '' : 'Product name field is required';
        closePicker();
    }

    productInput.closest('.field').addEventListener('click', function () {
        openPicker();
    });

    productInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openPicker();
        }
    });

    searchInput.addEventListener('input', function () {
        window.clearTimeout(searchTimer);
        const query = searchInput.value;
        searchTimer = window.setTimeout(function () {
            loadProducts(query);
        }, 300);
    });

    list.addEventListener('change', function (event) {
        const input = event.target;
        if (input.dataset.variantId) {
            const product = findProduct(input.dataset.productId);
            if (!product) return;
            const variant = product.variants.find(function (item) {
                return String(item.id) === String(input.dataset.variantId);
            });
            if (!variant) return;
            if (input.checked) {
                draft.set(String(variant.id), { label: variantLabel(product, variant) });
            } else {
                draft.delete(String(variant.id));
            }
            syncProductCheckbox(product);
            updateCount();
            return;
        }

        if (input.dataset.productCheck) {
            const product = findProduct(input.dataset.productCheck);
            if (!product) return;
            product.variants.forEach(function (variant) {
                const box = list.querySelector('[data-variant-id="' + variant.id + '"]');
                if (box) box.checked = input.checked;
                if (input.checked) {
                    draft.set(String(variant.id), { label: variantLabel(product, variant) });
                } else {
                    draft.delete(String(variant.id));
                }
            });
            input.indeterminate = false;
            updateCount();
        }
    });

    picker.addEventListener('click', function (event) {
        if (event.target.closest('[data-picker-close]')) closePicker();
    });

    addButton.addEventListener('click', applySelection);

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !picker.hidden) closePicker();
    });

    form.addEventListener('reset', function () {
        confirmed.clear();
        draft.clear();
        window.setTimeout(function () {
            productInput.value = '';
        }, 0);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    bulkPopup();    
});